import { Table as FBTable } from "flowbite-react";
import TableBody from "./TableBody";
import TableHead from "./TableHead";
import TableHeadCell from "./TableHeadCell";
import TableRow from "./TableRow";
import TableCell from "./TableCell";
import tenkenTheme from "../../configs/themes/tenkenTheme";

const Table = (props) => {
  return (
    <FBTable {...props} theme={tenkenTheme.table}>
      {props.children}
    </FBTable>
  );
};

Table.Body = TableBody;
Table.Head = TableHead;
Table.HeadCell = TableHeadCell;
Table.Row = TableRow;
Table.Cell = TableCell;

export default Table;
